import redisHost from "./redis-host";
import elasticsearch from "./elasticsearch";
import sqlDb from "./sql-db";
import unknown from "./unknown";

const allTypes = [redisHost, elasticsearch, sqlDb, unknown];

const combineEventHandlers = () => {
  // get a distinct list of event handlers names
  const eventHandlerNames = allTypes
    .map((t) => t.eventHandlers)
    .filter((eh) => eh)
    .map((eh) => Object.keys(eh))
    .reduce((p, c) => p.concat(c), [])
    .filter((v, i, a) => a.indexOf(v) === i);

  // make a combined proxy object
  const combined = eventHandlerNames.reduce((p, c) => {
    p[c] = (item, evtData, ui) =>
      getHandler(item).eventHandlers[c](item, evtData, ui);
    return p;
  }, {});

  return combined;
};

const getHandler = (i) => {
  if (i.id.endsWith("-redis-host")) return redisHost;
  if (i.id.endsWith("-elasticsearch")) return elasticsearch;
  if (i.id.endsWith("-sql-db")) return sqlDb;
  return unknown;
};

export default {
  hasData: true,
  hasRag: false,
  collections: {},

  layout: {
    radius: (i) => {
      const rad = getHandler(i).layout.radius;
      return rad instanceof Function ? rad(i) : rad;
    },
  },
  render: {
    enter: (i) => getHandler(i).render.enter(i),
    update: (i) => getHandler(i).render.update(i),
    exit: (i) => {
      const ext = getHandler(i).render.exit;
      if (ext) ext(i);
      i.elem.remove();
    },
  },
  eventHandlers: combineEventHandlers(),
  renderInfoHead: (i) => getHandler(i).renderInfoHead(i),
  renderInfoBody: (i) => getHandler(i).renderInfoBody(i),
};
